export const categories = [
    {
      id: 269,
      name: "Admin",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.619Z",
      updatedAt: "2024-12-06T18:33:41.619Z",
      subcategories: [
        {
          id: 270,
          name: "Receptionist",
          parentId: 269,
          createdAt: "2024-12-06T18:33:41.623Z",
          updatedAt: "2024-12-06T18:33:41.623Z"
        },
        {
          id: 271,
          name: "Floor Manager",
          parentId: 269,
          createdAt: "2024-12-06T18:33:41.623Z",
          updatedAt: "2024-12-06T18:33:41.623Z"
        },
        {
          id: 272,
          name: "Assistant",
          parentId: 269,
          createdAt: "2024-12-06T18:33:41.623Z",
          updatedAt: "2024-12-06T18:33:41.623Z"
        }
      ]
    },
    {
      id: 181,
      name: "Hairstylists",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 193,
          name: "Texture Specialist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 194,
          name: "Extensions Specialist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 195,
          name: "Chemical Specialist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 196,
          name: "Bridal Hairstylist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 197,
          name: "Men’s Stylist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 198,
          name: "Natural Hair Stylist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 190,
          name: "Colorist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 191,
          name: "Stylist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 192,
          name: "Updo Specialist",
          parentId: 181,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 182,
      name: "Barbers",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 199,
          name: "Traditional Barber",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 200,
          name: "Fade Specialist",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 201,
          name: "Beard Specialist",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 202,
          name: "Clipper Cut Specialist",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 203,
          name: "Hair Tattoo Artist",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 204,
          name: "Hot Towel Shave Specialist",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 205,
          name: "Modern Barber",
          parentId: 182,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 183,
      name: "Tattoo Artists",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 206,
          name: "Black and Grey Specialist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 207,
          name: "Color Tattoo Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 208,
          name: "Realism Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 209,
          name: "Traditional Tattoo Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 210,
          name: "Neo-Traditional Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 211,
          name: "Japanese Tattoo Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 212,
          name: "Portrait Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 213,
          name: "Biomechanical Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 214,
          name: "Watercolor Tattoo Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 215,
          name: "Dotwork Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 216,
          name: "Geometric Tattoo Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 217,
          name: "Minimalist Tattoo Artist",
          parentId: 183,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 184,
      name: "Estheticians",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 218,
          name: "Facialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 219,
          name: "Acne Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 220,
          name: "Waxing Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 221,
          name: "Microdermabrasion Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 222,
          name: "Chemical Peel Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 223,
          name: "Laser Technician",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 224,
          name: "Anti-Aging Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 225,
          name: "Body Treatment Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 226,
          name: "Brow and Lash Specialist",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 227,
          name: "Holistic Esthetician",
          parentId: 184,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 185,
      name: "Nail Technicians",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 228,
          name: "Manicurist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 229,
          name: "Pedicurist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 230,
          name: "Gel Nail Specialist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 231,
          name: "Acrylic Nail Specialist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 232,
          name: "Nail Art Specialist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 233,
          name: "Natural Nail Care Specialist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 234,
          name: "Spa Manicurist/Pedicurist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 235,
          name: "Nail Extension Specialist",
          parentId: 185,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 186,
      name: "Makeup Artists",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 236,
          name: "Bridal Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 237,
          name: "Editorial Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 238,
          name: "Special Effects Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 239,
          name: "Airbrush Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 240,
          name: "Celebrity Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 241,
          name: "Theatrical Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 242,
          name: "Film and TV Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 243,
          name: "Everyday Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 244,
          name: "Glam Makeup Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 245,
          name: "Cosmetic Tattoo Artist",
          parentId: 186,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 187,
      name: "Massage Therapists",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 246,
          name: "Swedish Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 247,
          name: "Deep Tissue Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 248,
          name: "Sports Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 249,
          name: "Prenatal Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 250,
          name: "Reflexologist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 251,
          name: "Trigger Point Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 252,
          name: "Hot Stone Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 253,
          name: "Aromatherapy Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 254,
          name: "Thai Massage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 255,
          name: "Myofascial Release Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 256,
          name: "Lymphatic Drainage Therapist",
          parentId: 187,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 188,
      name: "Eyelash Technicians",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 257,
          name: "Classic Lash Technician",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 258,
          name: "Volume Lash Technician",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 259,
          name: "Hybrid Lash Technician",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 260,
          name: "Lash Lift and Tint Specialist",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 262,
          name: "Lash Removal Specialist",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 263,
          name: "Lash Health Specialist",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 261,
          name: "Mega Volume Lash Technician",
          parentId: 188,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    },
    {
      id: 189,
      name: "Locticians",
      parentId: null,
      createdAt: "2024-12-06T18:33:41.601Z",
      updatedAt: "2024-12-06T18:33:41.601Z",
      subcategories: [
        {
          id: 264,
          name: "Starter Loc Specialist",
          parentId: 189,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 265,
          name: "Maintenance Loctician",
          parentId: 189,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 266,
          name: "Interlocking Specialist",
          parentId: 189,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 267,
          name: "Loc Extensions Specialist",
          parentId: 189,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        },
        {
          id: 268,
          name: "Micro Loc Specialist",
          parentId: 189,
          createdAt: "2024-12-06T18:33:41.606Z",
          updatedAt: "2024-12-06T18:33:41.606Z"
        }
      ]
    }
  ];